import './OurPackagesPage.css'
import React from 'react'
import Helmet from 'react-helmet'

import { ICONStarterPackage, ICONStandardPackage, ICONEnterprisePackage } from '../icons'
import Faqs from '../components/Faqs'


import Link from '../components/Link'

const featuresColumns = [
    'No. of included free actively maintained assets per month', 
    'Included Users', 
    'Cost per Actively Maintained Asset (Over Included Free Quota)', 
    'Addtional Users (/user/mth)', 
    '30 Day Free Trial (no credit card required)', 
    'No Lock-in Contracts',
    'Access iOS & Android Apps',
    'Create Audit Reports',
    'Create/Publish Maintenance Reports',
    'Scheduling & Analytics',
    'Email Support',
    'Priorty Phone Support',
    'Set  Up and Team Training'
]

const packageDetails = [
    {
        title: 'STARTER',
        color: 'white',
        icon: ICONStarterPackage,
        url: '/request-trial',
        divisions: [
            {
                cost: '$4.90',
                features: [
                    {
                        name: 'No. of included free actively maintained assets per month',
                        value: '1'
                    },
                    {
                        name: 'Included Users',
                        value: '1'
                    },
                    {
                        name: 'Cost per Actively Maintained Asset (Over Included Free Quota)',
                        value: '$4.90'
                    },
                    {
                        name: 'Addtional Users (/user/mth)',
                        value: '$15.00'
                    },
                    {
                        name: '30 Day Free Trial (no credit card required)',
                        value: true
                    },
                    {
                        name: 'No Lock-in Contracts',
                        value: true
                    },
                    {
                        name: 'Access iOS & Android Apps',
                        value: true
                    },
                    {
                        name: 'Create Audit Reports',
                        value: true
                    },
                    {
                        name: 'Create/Publish Maintenance Reports',
                        value: true
                    },
                    {
                        name: 'Scheduling & Analytics',
                        value: true
                    },
                    {
                        name: 'Email Support',
                        value: true
                    },
                    {
                        name: 'Priorty Phone Support',
                        value: false
                    },
                    {
                        name: 'Set  Up and Team Training',
                        value: false
                    }
                ]
            }
        ]
    },
    {
        title: 'STANDARD',
        icon: ICONStandardPackage,
        color: '#B5C3E2',
        url: '/request-trial',
        col: 3,
        divisions: [
            {
                cost: '$35',
                title: 'Standard 10',
                color: '#E1E6F3',
                features: [
                    {
                        name: 'No. of included free actively maintained assets per month',
                        value: '10'
                    },
                    {
                        name: 'Included Users',
                        value: '3'
                    },
                    {
                        name: 'Cost per Actively Maintained Asset (Over Included Free Quota)',
                        value: '$4.00'
                    },
                    {
                        name: 'Addtional Users (/user/mth)',
                        value: '$15.00'
                    },
                    {
                        name: '30 Day Free Trial (no credit card required)',
                        value: true
                    },
                    {
                        name: 'No Lock-in Contracts',
                        value: true
                    },
                    {
                        name: 'Access iOS & Android Apps',
                        value: true
                    },
                    {
                        name: 'Create Audit Reports',
                        value: true
                    },
                    {
                        name: 'Create/Publish Maintenance Reports',
                        value: true
                    },
                    {
                        name: 'Scheduling & Analytics',
                        value: true
                    },
                    {
                        name: 'Email Support',
                        value: true
                    },
                    {
                        name: 'Priorty Phone Support',
                        value: false
                    },
                    {
                        name: 'Set  Up and Team Training',
                        value: '$'
                    }
                ]
            },
            {
                cost: '$149',
                title: 'Standard 50',
                color: '#C1D1ED',
                features: [
                    {
                        name: 'No. of included free actively maintained assets per month',
                        value: '50'
                    },
                    {
                        name: 'Included Users',
                        value: '5'
                    },
                    {
                        name: 'Cost per Actively Maintained Asset (Over Included Free Quota)',
                        value: '$3.00'
                    },
                    {
                        name: 'Addtional Users (/user/mth)',
                        value: '$15.00'
                    },
                    {
                        name: '30 Day Free Trial (no credit card required)',
                        value: true
                    },
                    {
                        name: 'No Lock-in Contracts',
                        value: true
                    },
                    {
                        name: 'Access iOS & Android Apps',
                        value: true
                    },
                    {
                        name: 'Create Audit Reports',
                        value: true
                    },
                    {
                        name: 'Create/Publish Maintenance Reports',
                        value: true
                    },
                    {
                        name: 'Scheduling & Analytics',
                        value: true
                    },
                    {
                        name: 'Email Support',
                        value: true
                    },
                    {
                        name: 'Priorty Phone Support',
                        value: false
                    },
                    {
                        name: 'Set  Up and Team Training',
                        value: '$'
                    }
                ]
            },
            {
                cost: '$249',
                title: 'Standard',
                color: '#B5C3E2',
                features: [
                    {
                        name: 'No. of included free actively maintained assets per month',
                        value: '100'
                    },
                    {
                        name: 'Included Users',
                        value: '5'
                    },
                    {
                        name: 'Cost per Actively Maintained Asset (Over Included Free Quota)',
                        value: '$2.00'
                    },
                    {
                        name: 'Addtional Users (/user/mth)',
                        value: '$15.00'
                    },
                    {
                        name: '30 Day Free Trial (no credit card required)',
                        value: true
                    },
                    {
                        name: 'No Lock-in Contracts',
                        value: true
                    },
                    {
                        name: 'Access iOS & Android Apps',
                        value: true
                    },
                    {
                        name: 'Create Audit Reports',
                        value: true
                    },
                    {
                        name: 'Create/Publish Maintenance Reports',
                        value: true
                    },
                    {
                        name: 'Scheduling & Analytics',
                        value: true
                    },
                    {
                        name: 'Email Support',
                        value: true
                    },
                    {
                        name: 'Priorty Phone Support',
                        value: false
                    },
                    {
                        name: 'Set  Up and Team Training',
                        value: '$'
                    }
                ]
            }
        ]
    },
    {
        title: 'ENTERPRISE',
        color: '#46E4ED',
        icon: ICONEnterprisePackage,
        url: '/get-quote',
        divisions: [
            {
                title: 'Enterprise',
                preTitle: 'from',
                cost: '$399',
                features: [
                    {
                        name: 'No. of included free actively maintained assets per month',
                        value: '200 assets or more'
                    },
                    {
                        name: 'Included Users',
                        value: '10 or more users'
                    },
                    {
                        name: 'Cost per Actively Maintained Asset (Over Included Free Quota)',
                        value: '$1.50',
                        preValue: 'from'
                    },
                    {
                        name: 'Addtional Users (/user/mth)',
                        value: '$10.00',
                        preValue: 'from'
                    },
                    {
                        name: '30 Day Free Trial (no credit card required)',
                        value: true
                    },
                    {
                        name: 'No Lock-in Contracts',
                        value: true
                    },
                    {
                        name: 'Access iOS & Android Apps',
                        value: true
                    },
                    {
                        name: 'Create Audit Reports',
                        value: true
                    },
                    {
                        name: 'Create/Publish Maintenance Reports',
                        value: true
                    },
                    {
                        name: 'Scheduling & Analytics',
                        value: true
                    },
                    {
                        name: 'Email Support',
                        value: true
                    },
                    {
                        name: 'Priorty Phone Support',
                        value: true
                    },
                    {
                        name: 'Set  Up and Team Training',
                        value: '$'
                    }
                ]
            }
        ]
    },
]

function createIcon(icon) {
    return { __html: icon };
}

// Export Template for use in CMS preview
export const OurPackagesPageTemplate = ({ title, faqs }) => {

    return <main className="Packages-page">
            <Helmet>
                <title>Assetlogue – Our Packages</title>
            </Helmet>
            {title && <h1>{title}</h1>}

            <section>
                <div className='container container-large'>
                    <div className='packages-table'>
                        <div className='features-column'>
                            {featuresColumns.map(feature => 
                                <p key={feature}>{feature}</p>
                            )}
                        </div>
                        {packageDetails.map((pkg, index) => {
                            return <div key={`pkg-${index}`} className='package-table-package'>
                                <div className='package-illustration' dangerouslySetInnerHTML={createIcon(pkg.icon)} />
                                <div className='package-table-main' style={{ background: pkg.color }}>                                
                                    <h3>{pkg.title}</h3>
                                    <div className={`package-table-divisions ${pkg.col ? `col-${pkg.col}` : ''}`}>
                                        {pkg.divisions.map((division, index) => 
                                            <div key={`division-${index}`} className='package-table-division' style={{ background: division.color }}>
                                                <h4>{division.title}</h4>
                                                <h5>{division.preTitle && <span className='pre-value'>{division.preTitle}</span>}{division.cost}</h5>
                                                {division.features.map((feature, index) => 
                                                    <p key={`feature-${index}`} className={`package-table-feature ${feature.value === false ? 'feature-false' : ''}`}>
                                                        <span className='feature-name'>{feature.name}</span>
                                                        <span className={`feature-value ${feature.value === true ? 'feature-true' : ''}`}>
                                                            {feature.preValue && <span className='pre-value'>{feature.preValue}</span>}
                                                            {feature.value === true
                                                                ? <span className='checked'>&#10004;</span>
                                                                : feature.value === false
                                                                    ? '-'
                                                                : feature.value
                                                            }
                                                        </span>
                                                    </p>
                                                )}
                                            </div>
                                        )}

                                    </div>
                                    <div className='package-table-action' style={{ background: pkg.color }}>
                                        <Link className={`button ${pkg.color !== 'white' ? 'button-white' : ''}`} to={pkg.url}>TRY NOW</Link>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </section>

            <Faqs
                {...faqs}
            />
    </main>
}

// Export Default HomePage for front-end
const OurPackagesPage = ({ data: { page, settingsYaml } }) => (
    <OurPackagesPageTemplate {...page} {...page.frontmatter} {...settingsYaml} body={page.html} />
)

export const pageQuery = graphql`
  ## Query for OurPackagesPage data
  ## Use GraphiQL interface (http://localhost:8000/___graphql)
  ## $id is processed via gatsby-node.js
  ## query name must be unique to this file
  query OurPackagesPage($id: String!) {
    page: markdownRemark(id: { eq: $id }) {
    html
    frontmatter {
        title
    }
  }
    settingsYaml {
        faqs {
            title
            faq {
                question
                answer
            }
        }
    }
}
`


export default OurPackagesPage




// WEBPACK FOOTER //
// ./src/templates/OurPackagesPage.js